import {
  VALIDA_CP_START,
  VALIDA_CP_SUCCESS,
  VALIDA_CP_ERROR
} from '../actions'

const initialState = {
  loading: false,
  payload: null,
  error: null
}

const validaCP = (state = initialState, { type, payload, error }) => {

  switch(type) {

    case VALIDA_CP_START:
      return {
        ...state,
        loading: true,
        error: null
      }

    case VALIDA_CP_SUCCESS:
      return {
        ...state,
        loading: false,
        payload
      }

    case VALIDA_CP_ERROR:
      return {
        ...state,
        loading: false,
        error
      }

    default: return state

  }

}

export default validaCP